import script from "./VTitleWithBackLink.vue?vue&type=script&setup=true&lang=js"
export * from "./VTitleWithBackLink.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__